export default __webpack_public_path__ + "static/media/27_tag_bbq-garden.95d657e9.svg";